var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64952 10.9243C8.09196 8.11739 12.3879 6.26693 14.5374 5.37288C20.6747 2.82019 21.9499 2.37676 22.7811 2.36196C22.964 2.35889 23.3727 2.4042 23.6375 2.61905C23.8611 2.80046 23.9226 3.04553 23.952 3.21753C23.9815 3.38953 24.0181 3.78135 23.989 4.08751C23.6564 7.58196 22.2173 16.0621 21.4852 19.9759C21.1754 21.632 20.5655 22.1873 19.9749 22.2416C18.6916 22.3597 17.717 21.3935 16.4741 20.5787C14.529 19.3037 13.4302 18.51 11.5422 17.2658C9.36028 15.828 10.7747 15.0377 12.0182 13.7462C12.3436 13.4082 17.9981 8.26501 18.1075 7.79844C18.1212 7.74009 18.1339 7.52258 18.0047 7.40772C17.8755 7.29287 17.6848 7.33215 17.5472 7.36338C17.3521 7.40766 14.2449 9.46142 8.22548 13.5247C7.34351 14.1303 6.54464 14.4254 5.82889 14.4099C5.03982 14.3929 3.52198 13.9638 2.39362 13.597C1.00964 13.1471 -0.0903185 12.9093 0.00546327 12.1452C0.0553523 11.7473 0.603373 11.3403 1.64952 10.9243Z",
    fill: "#11A97D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.96ee27144837c5e332d5f6e9a10742fb.svg";
export { ForwardRef as ReactComponent };